import React from "react";

const Player = ({ name, ratings, captain, freeAgent, teamRole }) => {
  let classes = ["player"];
  let typeText;
  let playerType;

  const assistant = teamRole === "Assistant";

  if (captain) {
    classes.push("captain");
    typeText = "(C)";
  }

  if (freeAgent) {
    classes.push("free-agent");
    typeText = "(FA)";
  }

  if (assistant) {
    classes.push("assistant");
    typeText = "(A)";
  }

  if (captain || freeAgent || assistant) {
    playerType = <div className="player--details--type">{typeText}</div>;
  }

  return (
    <div className={classes.join(" ")}>
      <div className="player--details">
        <div className="player--details--name">{name}</div>
        {playerType}
      </div>
      <div className="player--ratings">
        <div className="player--rating twdtd">{ratings.twdtd / 10}</div>
        <div className="player--rating twdtj">{ratings.twdtj / 10}</div>
        <div className="player--rating twdtb">{ratings.twdtb / 10}</div>
        <div className="player--rating total">{ratings.total / 10}</div>
      </div>
    </div>
  );
};

export default Player;



// WEBPACK FOOTER //
// ./src/components/player/player.js